export function primitiveEncodeAndDecodeOptions({ encode, decode, }) {
    function ssp(defaultValue) {
        return { encode, decode, defaultValue };
    }
    return ssp;
}
